import './previewlinkgroupblock.less'

import {Background, m} from '@codeurs/front'
import {FunctionComponent, useState} from 'react'
import {useTranslation} from 'util/i18n'
import {PageLink as Link} from 'util/pagelink'
import {style} from 'util/style'
import {LinkArrow} from 'views/partials/linkarrow'
import {Theme} from 'views/theme'
import {Block} from './blocks'
import {PreviewLinkType} from './previewlinkblock'

const styles = style('previewlinkgroupblock')

export const PreviewLinkGroupBlock: FunctionComponent<{
  links: Array<PreviewLinkType>
}> = ({links}) => {
  const t = useTranslation('previewlink')
  return (
    <Block class={styles('container')}>
      <div class={styles}>
        {links.map(item => {
          const [isLoaded, setLoaded] = useState(false)
          return (
            <div class={styles('item')}>
              <Link to={item.link.url} title={item.title}>
                <div class={styles('item-imgcontainer')}>
                  {item.image && (
                    <div
                      class={styles('item-imgcontainer-image')
                        .is({loaded: isLoaded})
                        .toString()}
                    >
                      <Background
                        img={item.image}
                        alt={
                          item.image.alt ||
                          item.image.title?.replace(
                            /^.*[\\/]|(\.[^/.]+$)/g,
                            ''
                          ) ||
                          ''
                        }
                        onload={() => setLoaded(true)}
                      />
                    </div>
                  )}
                </div>
              </Link>
              <div class={styles('item-content')}>
                <Link to={item.link.url}>
                  <Theme.H2 class={styles('item-title')}>{item.title}</Theme.H2>
                </Link>
                <Theme.Wysiwyg class={styles('item-text')}>
                  {item.text}
                </Theme.Wysiwyg>
                <Theme.Link to={item.link.url}>
                  <span>
                    {item.link.description
                      ? item.link.description
                      : item.link.title
                        ? item.link.title
                        : t('readmore')}
                  </span>
                </Theme.Link>
                <LinkArrow mod={'blue'} class={styles('item-arrow')} />
              </div>
            </div>
          )
        })}
      </div>
    </Block>
  )
}
